import { Box } from "@mui/material";

import { Label, SelectorDiv, SelectorDivSmall, WhiteCircle, WhiteCircleSmall, Wrapper } from "./Selector.styles";

interface SelectorProps {
  isSelected: boolean;
  changeSelection?: (selected: boolean) => void;
  leftLabel?: React.ReactNode;
  rightLabel?: React.ReactNode;
  size?: string;
  disabled?: boolean;
}

export default function Selector({
  isSelected = false,
  changeSelection,
  leftLabel = "",
  rightLabel = "",
  size = "default",
  disabled = false,
}: SelectorProps) {
  function handleClick() {
    if (changeSelection && !disabled) {
      changeSelection(!isSelected);
    }
  }

  return (
    <Wrapper>
      {leftLabel ? (
        typeof leftLabel === "string" ? (
          <Label data-testid="left-label-selector">{leftLabel}</Label>
        ) : (
          <Box sx={{ mx: 0.75 }}>{leftLabel}</Box>
        )
      ) : null}
      {size === "small" ? (
        <SelectorDivSmall
          data-testid="selector-div-small"
          disabled={disabled}
          isSelected={isSelected}
          onClick={handleClick}
        >
          <WhiteCircleSmall />
        </SelectorDivSmall>
      ) : (
        <SelectorDiv data-testid="selector-div" disabled={disabled} isSelected={isSelected} onClick={handleClick}>
          <WhiteCircle />
        </SelectorDiv>
      )}
      {rightLabel ? (
        typeof rightLabel === "string" ? (
          <Label data-testid="right-label-selector">{rightLabel}</Label>
        ) : (
          <Box sx={{ mx: 0.75 }}>{rightLabel}</Box>
        )
      ) : null}
    </Wrapper>
  );
}
